module.exports = __webpack_public_path__ + "media/DataViz_low.5f5b0575.mp4";